<template>
  <div>
    <b-button variant="white" class="mr-3 float-right" style="border:1px solid; border-color: #0090CD;" @click="openNewCollection">
      <i class="fas fa fa-1x fa-plus mr-2"></i>
      {{$t("scene.add_scene")}}
    </b-button>

    <!-- Modal for view zone -->
    <groups-central-unit :cu="cuGroups" :readonlyMode="true" v-model="modalGroupsCuVisible" @hide="resetGroupsCuModal"/>  

    <!-- Crea nuova collection Modal-->
    <b-modal
      ref="modal"
      size="lg"
      :id="'modal-new-collection'+this._uid"
      :saveSubmit="saveSubmit"
      :title="$t('scene.modal_title')"
      :ok-title="$t('user_modal.button_save')"
      :cancel-title="$t('user_modal.button_cancel')"
      @ok="handleOk"
    >
      <b-row>
      <b-col cols="9">
        
        <!--input name of scene -->
        <b-form-group class="ml-2">
          <label class="typo-label">{{$t("scene.scene_name")}}</label>
          <b-form-input
            v-model="sceneName"
            type="text"
            :state="validation_sceneName"
          ></b-form-input>
          <b-form-invalid-feedback
            :state="validation_sceneName"
          >{{$t("signup.validation_null")}}</b-form-invalid-feedback>
         </b-form-group>

          <!-- label cu group selection-->
          <b-row class="px-3 py-2 mt-2">
           <b-col cols="4">
                <label class="typo-label">{{$t("collection.label_select_cu")}}</label>
            </b-col>
            <b-col cols="5">
                <label class="typo-label">{{$t("scene.label_select_scene")}}</label>
            </b-col>
          </b-row>

          <div v-for="(item,pos) in this.itemsScene" :key="pos" class="px-3 mb-3">
              <b-row>
                <!-- select central unit -->
                <b-col cols="4">
                <b-form-select v-model="item.cu" :options="cu_options" @change="onChangeCent($event+'_'+pos)"  :state="validation_collectionCu"></b-form-select>
                <b-form-invalid-feedback :state="validation_collectionCu">{{$t("signup.validation_null")}}</b-form-invalid-feedback>
              </b-col>
  
                <!-- select scene -->
                <b-col cols="5">
                  <b-form-select v-model="item.scene" :options="scene_options[pos]" :state="validation_collectionScene"></b-form-select>
                  <b-form-invalid-feedback :state="validation_collectionScene">{{$t("signup.validation_null")}}</b-form-invalid-feedback>
                </b-col>

                <!-- plus button -->
                <b-col cols="1">   
                  <b-button style="color: #0090CD" @click="addInput()"><i class="fas fa fa-1x fa-plus no-border"></i></b-button>
                </b-col>        
      
                <!-- remove button -->
                <b-col cols="1">   
                    <b-button v-if="pos>0" @click="function(){itemsScene.splice(pos)}"><i class="fa fa-times pt-1"></i></b-button>
                </b-col>  
    
              </b-row>     
          </div> 
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import GroupsCentralUnit from '@/components/GroupsCentralUnit';
import { uuid } from 'vue-uuid'; 


export default {
  name: "AddScene",
  components:{
    GroupsCentralUnit
  },
  data() {
    return {
     sceneName: "",
     cuGroups: null,
     modalGroupsCuVisible:false,
     saveSubmit: "false",
     illum_type: "lighting",
     itemsScene:[
        {
          cu: '',
          scene: ''
        }
      ],
     plantId:"",
     cu_options:[],
     scene_options:[],
     currentScene: { }
    };
  },
   props: {
    ambientId:null,
  },
  computed: {
    validation_sceneName() {
      if (this.saveSubmit == true) return this.sceneName.length > 0;
    },
    validation_collectionCu() {
      if (this.saveSubmit == true) return this.itemsScene[0].cu != "" ;
    },
    validation_collectionScene() {
      if (this.saveSubmit == true) return  this.itemsScene[0].scene != "";
    },
    cuIdList() 
    {
      console.log("Unit details", this.$store.state.plantUnits);
      var cuList=[];
      for(var i=0;i<this.$store.state.plantUnits.length;i++)
      {
        //esclusione delle centrali cablecom
        if (this.$store.state.plantUnits[i].cu_type != "cablecom")
          cuList.push(this.$store.state.plantUnits[i].cu_type+"_"+this.$store.state.plantUnits[i].cu_id);
      }
      return cuList;
    }
  },
  methods: {
    showGroups(cu)
    {
      var cent_sel=[];
      cent_sel=cu.split("_");
      if(cent_sel.length > 1){
        var plant = this.$store.state.plantUnits;
        var curr = plant.filter((x) => x.cu_id == cent_sel[1]);
        this.cuGroups = curr[0];
        this.modalGroupsCuVisible = true;
        console.log("Open modal groups on Cu", this.cuGroups);
      }
    },
    resetGroupsCuModal() {
      this.cuGroups = null;
    },
    openNewCollection(bvModalEvt) {
      this.cu_options=this.cuIdList;
      this.clearInput();
      this.$bvModal.show('modal-new-collection'+this._uid);
    },
    onChangeCent(cent_selected) {
      console.log("Cent selected: ", cent_selected);
      var cent_sel=[];
      cent_sel=cent_selected.split("_");
      console.log("Cent selected: ", cent_sel.toString());

      var sceneList=[];
      //cerco array di scene per ogni centrale selezionata
      for(var i=0;i<this.$store.state.plantUnits.length;i++)
      {
        if(this.$store.state.plantUnits[i].cu_type == cent_sel[0] && this.$store.state.plantUnits[i].cu_id == cent_sel[1])
        {
          //sceneList=sceneList.concat(this.$store.state.plantUnits[i].scene[0].descrizione);
          for(var j=0;j<this.$store.state.plantUnits[i].scene.length;j++)
          {
            //creo un unico array concatenando le scene
            sceneList=sceneList.concat(this.$store.state.plantUnits[i].scene[j].num_scena + " - " + this.$store.state.plantUnits[i].scene[j].descrizione.split('$')[0]);
          }
        }
      }
      //tolgo i valori duplicati nell'array complessivo di tutti i gruppi per la centrale
      sceneList = [...new Set(sceneList)];
      console.log("sceneList: ",sceneList);
      //assegno l'elenco delle scene al b-select di selezione dei gruppi per centrale
      if(this.scene_options[cent_sel[2]])
        this.scene_options[cent_sel[2]]=sceneList;
       else
        this.scene_options.push(sceneList);
      
      this.$forceUpdate();
      console.log("option_scene",this.scene_options.toString());

    },
    clearInput()
        {
         this.itemsScene=[
                {
                  cu: '',
                  scene: '',
                }
                ];
         this.scene_options=[]; 
         this.saveSubmit=false;    
         this.sceneName="";
        }, 
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      this.saveSubmit = true;
      // Trigger submit handler
      this.saveScene();
    },
    addInput()
      {
        var newItem={ cu: '', scene: ''};
        this.itemsScene.push(newItem);   
      },
    saveScene() {     
      if (!this.validation_sceneName || !this.validation_collectionCu || !this.validation_collectionScene) return; 
      
      this.currentScene.type="Cu";
      this.currentScene.sceneEnabled=false;
      this.currentScene.sceneName=this.sceneName;
      this.currentScene.collections=this.itemsScene;
      this.currentScene.plantId=this.$store.state.currentPlant.id;
      this.currentScene.ambientId=this.ambientId;
      this.currentScene.sceneInput="";
      this.currentScene.program="";
      this.currentScene.sceneMode="";
      this.currentScene.sceneId = '' + uuid.v1();
 
      console.log("save scene...");
      this.$store.dispatch("dbSaveScene", this.currentScene);
      
      // Hide the modal manually
            this.$nextTick(() => {
              this.$refs.modal.hide();
            });
    }
  }
};
</script>
